import { lazyNamed } from 'src/utils/lazyNamed';

export const ReferencePerAdmedia = {
  List: lazyNamed(() => import('./containers/List'), 'ReferencePerAdmediaList'),
  Edit: lazyNamed(() => import('./containers/Edit'), 'ReferencePerAdmediaEdit'),
};
